import RestaurantStatsList from "./RestaurantStatsList";
import RestaurantStatsIcon from "@mui/icons-material/BarChart";

const restaurantsStats = {
  list: RestaurantStatsList,
  icon: RestaurantStatsIcon,
};

export default restaurantsStats;
